"use client";

// @ts-ignore - TypeScript has issues with Radix UI exports
const CollapsiblePrimitive = require("@radix-ui/react-collapsible");

const Collapsible = CollapsiblePrimitive.Root;

const CollapsibleTrigger = CollapsiblePrimitive.CollapsibleTrigger;

const CollapsibleContent = CollapsiblePrimitive.CollapsibleContent;

export { Collapsible, CollapsibleTrigger, CollapsibleContent };
